import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["FAQAccordion"] */ "/vercel/path0/src/components/FAQAccordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterSignup"] */ "/vercel/path0/src/components/NewsletterSignup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewsWidget"] */ "/vercel/path0/src/components/ReviewsWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/src/components/ui/button.tsx");
